export const VOLC_ASSETS_CHANGED_EVENT = 'volc-assets-changed'

export function notifyVolcAssetsChanged(detail = {}) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(VOLC_ASSETS_CHANGED_EVENT, { detail }))
}

export function onVolcAssetsChanged(handler) {
  if (typeof window === 'undefined') return () => {}

  const listener = (event) => handler(event.detail || {})
  window.addEventListener(VOLC_ASSETS_CHANGED_EVENT, listener)
  return () => window.removeEventListener(VOLC_ASSETS_CHANGED_EVENT, listener)
}
